import {
  createApp
} from 'vue'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './rqeuest/index.js';
import Bus from './bus.js' /// mitt 总线程引入
import utils from './common/index.js' /// 通用方法引入


//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | 云坐席`;
  const role = store.state.token;
  if (!role) {
    if (to.path == '/login') {
      next();
    } else {
      next('/login');
    }
  } else {
    if (to.path == '/login') {
      next('/');
    } else {
      next();
    }
  }
});

const app = createApp(App);

app.config.globalProperties.$http = http;
app.config.globalProperties.$dhweb = new DHAlarmWeb();
app.config.globalProperties.$Bus = Bus;
app.config.globalProperties.$Utils = utils;

app.use(ElementPlus, {
  locale
});
app.use(store);
app.use(router);

app.mount('#app');
